<app-common-socket-logs
	[log]="currentLog"
	[title]="title"
>
	<!-- <div class="btn-groups">
		<ng-container *ngIf="isWizard">
			<button class="button-general" (click)="goNext()" [disabled]="disableView">Next</button>
		</ng-container>
		<ng-container *ngIf="!isWizard">
			<button class="button-general" (click)="viewData()" [disabled]="disableView">View</button>
		</ng-container>
	</div> -->
</app-common-socket-logs>
